export function downloadFile(blob: Blob, name: string): void {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = name;
    link.click();
}

export function objectsEqual(...objects: any[]): boolean {
    let previousJson: string;
    for (const json of objects.map(o => JSON.stringify(o))) {
        if (!previousJson) {
            previousJson = json;
            continue;
        }

        if (previousJson !== json) {
            return false;
        }
    }

    return true;
}

export function removeSpecialCharacters(value: string | number): string {
    return ('' + value).replace(/[^a-zA-Z0-9]/g, '');
}

export function decimalPlaces(num) {
    const match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) { return 0; }
    return Math.max(
         0,
         // Number of digits right of decimal point.
         (match[1] ? match[1].length : 0)
         // Adjust for scientific notation.
         - (match[2] ? +match[2] : 0));
  }

export const normalize = (): (s: string) => string => {
  const mapping = {
    'Â': 'A', 'À': 'A', 'Á': 'A', 'Ä': 'A', 'Ã': 'A',
    'È': 'E', 'É': 'E', 'Ë': 'E', 'Ê': 'E', '/': '-',
    'Ì': 'I', 'Í': 'I', 'Ï': 'I', 'Î': 'I',
    'Ò': 'O', 'Ó': 'O', 'Ö': 'O', 'Ô': 'O',
    'Ù': 'U', 'Ú': 'U', 'Ü': 'U', 'Û': 'U',
    'â': 'a', 'à': 'a', 'á': 'a', 'ä': 'a', 'ã': 'a',
    'è': 'e', 'é': 'e', 'ë': 'e', 'ê': 'e',
    'ì': 'i', 'í': 'i', 'ï': 'i', 'î': 'i',
    'ò': 'o', 'ó': 'o', 'ö': 'o', 'ô': 'o',
    'ù': 'u', 'ú': 'u', 'ü': 'u', 'û': 'u',
    'Ñ': 'N', 'ñ': 'n', 'Ç': 'C', 'ç': 'c'
  };

  return (str): string => {
    if (!str) { return ''; }

    const ret = [];

    for (let i = 0, j = str.length; i < j; i++) {
      const c = str.charAt(i);
      mapping.hasOwnProperty(str.charAt(i)) ? ret.push(mapping[c]) : ret.push(c);
    }

    return ret.join('');
  };
}
